import React from 'react'
import Navbar from './../Navbar/Navbar';
import Footer from './../Footer/Footer';
import { Offline} from "react-detect-offline";
import { Outlet, useNavigate } from 'react-router-dom';
import WifiOffIcon from '@mui/icons-material/WifiOff';
// import LoadingScreen from '../LoadingScreen/LoadingScreen';



export default function Layout({userData, setuserData, userDataName }) {
  let navigate = useNavigate()

  // function to remove token after signOut
  function signOut(){
    localStorage.removeItem('token')
    setuserData(null)
    navigate('/')
  }
  return (
    <>
      <Navbar
        userData={userData}
        signOut={signOut}
        userDataName={userDataName}
      />
      <div className="container py-4 mt-5">
        <Outlet></Outlet>
      </div>
      <Footer />

      {/* Detect offline network Status  */}
      <Offline>
        <span
          style={{ "--fa-animation-duration": "2s", "--fa-fade-opacity": 0.6 }}
          className="networkStatus alert alert-danger fa-fade py-2"
        >
          Check your network connection!
          <WifiOffIcon />
        </span>
      </Offline>
    </>
  );
}
